import KeyInformation from '@/pages/CompanyReport/components/Introduction/components/KeyInformation';
import { useNonBankMetrics } from '@/pages/CompanyReport/components/Health/Hooks';

type Props = { canonicalURL: string };

export const KeyInformationNonBank = ({ canonicalURL }: Props) => {
  const { keyMetrics, metrics } = useNonBankMetrics(canonicalURL);
  return (
    <KeyInformation direction="row" keyMetrics={keyMetrics} metrics={metrics} />
  );
};
